const login = 'login'

export const getLogin = () => {
  const storedLogin = window.sessionStorage.getItem(login)
  return JSON.parse(storedLogin)
}

export const saveLogin = (payload) => {
  const stringLogin = JSON.stringify(payload)
  window.sessionStorage.setItem(login, stringLogin)
}

export const destroyLogin = () => {
  const keysToRemove = [login]
  keysToRemove.forEach((key) => sessionStorage.removeItem(key))
}

export default {
  getLogin,
  saveLogin,
  destroyLogin
}
